const getters = {
  shop: state => state.shop.info,
  token: state => state.user.token,
  user_name: state => state.user.user_name,
  productList: state => state.product.list,
  productTotal: state => state.product.total,
  // token: state => state.user.token,
  // avatar: state => state.user.avatar,
  // name: state => state.user.name,
  // openShop: state => state.user.openShop,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js